import PropTypes from 'prop-types';
import { useState } from 'react';
import { useQuery } from '@apollo/client';
import { format, parseISO } from 'date-fns';
import { Card } from '@mui/material';
import DataTable from 'src/components/DataTable';
import { TwilioStatusBadge } from 'src/components/table/twilio-status-badge';
import { GET_MANUAL_TEXTS_BY_BATCH_ID_PAGINATED } from 'src/graphql/manual_texts/queries';

// Recipients table for an upload-numbers texting task. Its recipients live in the
// linked manual_text_batch's manual_texts rows (raw phone numbers), not in voters_queries.
export const ManualNumberTaskRecipients = ({ manualTextBatchId }) => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const { data, loading } = useQuery(GET_MANUAL_TEXTS_BY_BATCH_ID_PAGINATED, {
    variables: { id: manualTextBatchId, limit, offset: (page - 1) * limit },
    skip: !manualTextBatchId,
  });

  const texts = data?.rows ?? [];
  const total = data?.total?.aggregate?.count ?? 0;

  const columns = [
    { dataField: 'from', text: 'From' },
    { dataField: 'to', text: 'To' },
    {
      dataField: 'date_sent',
      text: 'Date Submitted',
      formatter: (cell) => (cell ? format(parseISO(cell), 'MMM dd, yyyy - hh:mma') : '--'),
    },
    {
      dataField: 'status',
      text: 'Status',
      formatter: (_cell, row) => (
        <TwilioStatusBadge
          value={row.direct_snd_status ?? row.status}
          twilioErrorCode={row.twilio_error_code}
          directSndErrorCode={row.direct_snd_error}
        />
      ),
    },
  ];

  return (
    <Card sx={{ marginTop: 4, padding: 2 }}>
      <DataTable
        size="small"
        keyField="manual_text_id"
        loading={loading}
        data={texts}
        columns={columns}
        pagination={{ page, limit, total }}
        onTableChange={(type, { page: newPage, limit: newLimit }) => {
          if (newLimit) {
            setLimit(newLimit);
            setPage(1);
          }
          if (newPage) {
            setPage(newPage);
          }
        }}
        remote
      />
    </Card>
  );
};

ManualNumberTaskRecipients.propTypes = {
  manualTextBatchId: PropTypes.number,
};
